var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.task.taskType.alias === 'QUIZ_IMAGE')?_c('div',[_c('img',{staticClass:"option-image",class:{
            'correct-answer': _vm.isCorrect,
            'wrong-answer': !_vm.isCorrect,
            'visible': _vm.isAnswerVisible },attrs:{"src":("" + (_vm.answer.imageUrl)),"alt":"option image"}})]):_c('div',{staticClass:"option-text",class:{
        'correct-answer': _vm.isCorrect,
        'wrong-answer': !_vm.isCorrect,
        'visible': _vm.isAnswerVisible }},[_vm._v(" "+_vm._s(_vm.answer.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }